module.exports = __webpack_public_path__ + "img/hot02.c9e2d6d6.png";